// Task 11 (SP2 §8) — client-side gate for the supervisor
// transaction-balance-override affordance on TransactionsPanel. Mirrors the
// bare-action pattern used by canQueueEvict / canSendDirectNote: cosmetic
// only — the server (Task 8's POST /:id/transactions/:transactionId/override)
// is authoritative on `remittance.balance`; this only decides whether to
// render the Override button.
export function canOverrideTransactionBalance(
  user: { permissions?: string[] } | null | undefined,
): boolean {
  return (
    !!user?.permissions?.includes("remittance.balance") ||
    !!user?.permissions?.includes("admin")
  );
}
